<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
<!--    <div class="header-top container-fuild hidden-xs">-->
<!--      <div class="container">-->
<!--        <div class="server pull-left">-->
<!--          <span class="glyphicon glyphicon-earphone"></span>888-888-888-->
<!--          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com-->
<!--          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
<!--        </div>-->
<!--        <div class="shejiao pull-right">-->
<!--          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！-->
<!--          <span class="glyphicon glyphicon-hand-left"></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs" style="min-width: 1300px">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img  src="@/assets/img/logo_zhu8.png">
        <!--logo_black.png-->
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{ $t(item.name) }}

            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{ $t(i.name) }}</router-link>
            </dt>
          </dl>
        </li>
        <!-- 语言包 -->
        <Lang class="right-menu-item" style="position: relative;left: 5%;top: 7px"></Lang>
      </ul>
    </div>

    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
<!--      <div class="header-nav-m-logo">-->
<!--        <img class="center-block" style="height: 50px;width: 300px" src="@/assets/img/logo_zhu8.png" alt="logo">-->
<!--        &lt;!&ndash; 语言包 &ndash;&gt;-->
<!--&lt;!&ndash;        <Lang class="right-menu-item"  style="position: relative;left: 90%;top:75%"/>&ndash;&gt;-->
<!--      </div>-->
      <!-- 导航栏 -->

      <div class="header-nav-m-menu text-center" >
<!--         <img classlass="center-blocknter-block" style="height: 50px;width: 300px;position: relative;top:5px;right: 150px" src="@/assets/img/logo_zhu8.png" alt="logo">-->
            <img classlass="center-blocknter-block" style="height: 45px;width: 150px;float:left;position: relative;top:-4px;left: 5px" src="@/assets/img/logo_zhu82.png" alt="logo">

<!--          <div style="width: 30px;height: 30px;margin-right:100px;float:left;margin-top: 10px">-->
<!--            -->
<!--          </div>-->

<!--        position: relative;top:10px;-->
<!--        {{ $t(menuName) }}-->
        <!-- 语言包 -->


          <div
            class="header-nav-m-menu-wrapper"
          >
            <Lang class="right-menu-item" style="float:left;position: relative;top:16px;right: 20px"/>
            <span :class="menuClass" style="float:left;font-size: 25px;margin-top: 10px"  data-toggle="collapse"
                  data-target="#menu" @click="menuClick"></span>
        </div>

        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navListphone"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ $t(item.name) }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "heads.homePage",
      menuClass: "glyphicon glyphicon-th-list",
      navList: [
        {
          name: "heads.homePage",
          path: "/",
          children: []
        },
        {
          name: "heads.certificates",
          path: "/software",
          children: [
            {
              name: "heads.lithiumBattery",
              path: "/software/smartTown"
            },
            {
              name: "heads.ceCertificate",
              path: "/software/bigData"
            },
            {
              name: "heads.pseCertificate",
              path: "/software/smartTown2"
            },
            {
              name: "heads.kcCertificate",
              path: "/software/smartTown3"
            },
            {
              name: "heads.cccCertificate",
              path: "/software/smartTown4"
            }
          ]
        },
        {
          name: "heads.ourservices",
          path: "/service",
          children: [
          ]
        },
        {
          name: "heads.newstrends",
          path: "/newsinformation",
          children: []
        },
        {
          name: "heads.companyIntroduction",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "heads.reportQuery",
          path: "/jobchance",
          children: []
        },
        {
          name: "heads.contactUs",
          path: "/contactus",
          children: []
        }
      ],
      navListphone: [
        {
          name: "heads.homePage",
          path: "/",
          children: []
        },
        {
          name: "heads.certificates",
          path: "/software",
          children: [
            {
              name: "heads.lithiumBattery",
              path: "/software/smartTown"
            },
            {
              name: "heads.ceCertificate",
              path: "/software/bigData"
            },
            {
              name: "heads.pseCertificate",
              path: "/software/smartTown2"
            },
            {
              name: "heads.kcCertificate",
              path: "/software/smartTown3"
            },
            {
              name: "heads.cccCertificate",
              path: "/software/smartTown4"
            }
          ]
        },
        {
          name: "heads.ourservices",
          path: "/ServiceDetail",
          children: [
          ]
        },
        {
          name: "heads.newstrends",
          path: "/newsinformation",
          children: []
        },
        {
          name: "heads.companyIntroduction",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "heads.reportQuery",
          path: "/jobchance",
          children: []
        },
        {
          name: "heads.contactUs",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-th-list") {
        this.menuClass = "glyphicon glyphicon-th-list";
      } else {
        this.menuClass = "glyphicon glyphicon-th-list";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fdfcfc;
  transition: all ease 0.6s;
  position: relative; /* 或者使用 relative */
  z-index: 100;
  filter:drop-shadow(2px 0px 5px black)
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 109px;

}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 470px;
  height: 80px;
  float: left;
  position: relative;
}



/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 470px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 46px;
    font-size: 20px;
    line-height: 50px;
    background: rgba(227, 223, 223, 0.29);
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 2px;
    margin-top: -20px;
    width: 48px;
    height: 40px;
    color: #181717;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: rgba(134, 132, 132, 0.59);
    z-index: 9999999;
    /*filter:drop-shadow(2px 0px 2px black)*/
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue